import React from 'react';
import styled from 'styled-components';

const PrivacySection = styled.section`
  background-color: var(--white);
  padding: 5rem 0;
`;

const PrivacyContainer = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
`;

const PrivacyHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const PrivacyContent = styled.div`
  text-align: right;
  direction: rtl;
  
  h2 {
    margin-top: 2rem;
    margin-bottom: 1rem;
    color: var(--primary-blue);
  }
  
  p {
    margin-bottom: 1.5rem;
    line-height: 1.8;
  }
  
  ul {
    margin: 1.5rem 0;
    padding-right: 1.5rem;
  }
  
  li {
    margin-bottom: 0.8rem;
  }
`;

const Privacy = () => {
  return (
    <PrivacySection id="privacy">
      <PrivacyContainer>
        <PrivacyHeader>
          <h1>מדיניות פרטיות</h1>
        </PrivacyHeader>
        
        <PrivacyContent>
          <p>
            אנו במכבסה מקצועית מכבדים את פרטיותך ומחויבים להגן על המידע האישי שלך. 
            מדיניות פרטיות זו מסבירה כיצד אנו אוספים, משתמשים ומגנים על המידע האישי שלך בעת השימוש באתר שלנו.
          </p>
          
          <h2>איסוף מידע</h2>
          <p>
            אנו אוספים מידע אישי שאתה מספק לנו באופן ישיר, כגון:
          </p>
          <ul>
            <li>שם מלא</li>
            <li>פרטי קשר (כתובת דוא"ל, מספר טלפון)</li>
            <li>כתובת למשלוח</li>
            <li>פרטי תשלום (במידה ומבוצעת רכישה)</li>
          </ul>
          <p>
            בנוסף, אנו עשויים לאסוף מידע באופן אוטומטי בעת הביקור באתר שלנו, כגון כתובת IP, סוג דפדפן, זמני כניסה ויציאה ודפים שנצפו.
          </p>
          
          <h2>שימוש במידע</h2>
          <p>
            אנו משתמשים במידע שנאסף למטרות הבאות:
          </p>
          <ul>
            <li>לספק את השירותים שביקשת</li>
            <li>לעבד הזמנות ותשלומים</li>
            <li>לתקשר איתך בנוגע להזמנות, שירותים או שאלות</li>
            <li>לשפר את האתר והשירותים שלנו</li>
            <li>לשלוח עדכונים ומידע שיווקי (רק אם הסכמת לכך)</li>
          </ul>
          
          <h2>שיתוף מידע</h2>
          <p>
            אנו לא מוכרים, מסחרים או משכירים את המידע האישי שלך לצדדים שלישיים. אנו עשויים לשתף מידע עם:
          </p>
          <ul>
            <li>ספקי שירות שעוזרים לנו בתפעול העסק (כגון חברות משלוחים, מעבדי תשלומים)</li>
            <li>רשויות אכיפת חוק כאשר נדרש על פי חוק</li>
          </ul>
          
          <h2>אבטחת מידע</h2>
          <p>
            אנו נוקטים באמצעי אבטחה מתאימים כדי להגן על המידע האישי שלך מפני גישה, שימוש או חשיפה בלתי מורשים.
            עם זאת, שום שיטת העברה באינטרנט או אחסון אלקטרוני אינה מאובטחת ב-100%.
          </p>
          
          <h2>עוגיות (Cookies)</h2>
          <p>
            האתר שלנו משתמש בעוגיות כדי לשפר את חווית המשתמש שלך. עוגיות הן קבצי טקסט קטנים שמאוחסנים במכשיר שלך.
            אתה יכול להגדיר את הדפדפן שלך לדחות עוגיות, אך הדבר עלול לפגוע בחלק מהפונקציונליות של האתר.
          </p>
          
          <h2>זכויותיך</h2>
          <p>
            יש לך זכות לגשת, לתקן, למחוק או להגביל את עיבוד המידע האישי שלך. אם ברצונך לממש זכויות אלה, אנא צור איתנו קשר.
          </p>
          
          <h2>שינויים במדיניות הפרטיות</h2>
          <p>
            אנו עשויים לעדכן את מדיניות הפרטיות שלנו מעת לעת. נפרסם כל שינוי באתר זה ונעדכן את תאריך העדכון.
          </p>
          
          <h2>יצירת קשר</h2>
          <p>
            אם יש לך שאלות לגבי מדיניות הפרטיות שלנו, אנא צור איתנו קשר:
          </p>
          <p>
            טלפון: 055-4528012<br />
            דוא"ל: shemtovmimi@gmail.com
          </p>
          
          <h2>תאריך עדכון אחרון</h2>
          <p>
            מדיניות פרטיות זו עודכנה לאחרונה בתאריך: 13 ביולי 2025
          </p>
        </PrivacyContent>
      </PrivacyContainer>
    </PrivacySection>
  );
};

export default Privacy;
